module.exports = __webpack_public_path__ + "static/carousel-05@2x-994b0bcc17826201fd1f09048f6b9847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/carousel-05@2x.jpg
// module id = 2522
// module chunks = 168707334958949